import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-nominativo-elimina',
  templateUrl: './nominativo-elimina.component.html',
  styleUrls: ['./nominativo-elimina.component.css']
})
export class NominativoEliminaComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NominativoEliminaComponent>,
    private snackBar: MatSnackBar,
    private srvUtilita: UtilitaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }


  ngOnInit(): void {
    if (this.data.idRichiesta) { }


   // console.log('row', this.data.row)
   // console.log('row idRichiestaIscrizioneNominativo', this.data.row.idRichiestaIscrizioneNominativo)
    if (this.data.idRichiestaIscrizioneNominativo > 0) { } 

    

  }


  btnSalva() {

    const obj =
    {
      idUtenteProfilo: this.data.idutente,
      idRichiestaProfilo: this.data.idRichiesta
    }
    this.srvUtilita.postObj('Clienti/EliminaNominativoAllaRichiesta', this.data.row).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()


    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
     // console.log(err.error.Message, 'ERRORE');
    })

  }

  btnAnnulla() {
    this.dialogRef.close();
  }


  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }


}
